const elements = {
  toggles: document.body.querySelectorAll('.js-navigation-modal-trigger'),
};

const parentActive = 'nav-modal-is-active';
const active = 'is-active';

function toggleHandler(toggle) {
  const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
  
  toggle.parentElement.parentElement.classList.toggle(active);
  toggle.setAttribute('aria-expanded', !isExpanded);
  
  document.body.classList.toggle(parentActive);
  toggle.nextElementSibling.setAttribute(
    'aria-hidden',
    !toggle.parentElement.parentElement.classList.contains(active),
  );
}

function closeHandler(event) {
  if (document.body.classList.contains(parentActive)) {
    if (event.target.classList.contains('js-navigation-modal-trigger')) return;
    elements.toggles.forEach((toggle) => {
      if (toggle.parentElement.parentElement.contains(event.target)) return;
      if (toggle.parentElement.parentElement.classList.contains(active)) {
        toggleHandler(toggle);
      }
    });
  }
}

function init() {
  if (elements.toggles.length) {
    elements.toggles.forEach((toggle) => {
      toggle.addEventListener('click', event => toggleHandler(event.target));
    });

    document.addEventListener('click', closeHandler);
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/_navigation-modal/navigation-modal.js